<template>
  <div class="price">
    <ul class="pricecards">
      <li><img src="./assets/pricecard-trial.png" alt="トライアル"></li>
      <li><img src="./assets/pricecard-basic.png" alt="ベーシック"></li>
    </ul>
    <p>※トライアルは、自動的にベーシック（有料）に切り替わることはありません<br>※1.返信数とは、アドバイザーと相談者の返信の合計数になります<br>※2.税込み金額です</p>
  </div>
</template>
<script scoped>
export default {
  props: ['linkToPaymentPage']
}
</script>
<style>
.price {
	margin-bottom: 2em;
}

.price ul {
	list-style: none;
	padding: 0;
}

ul.pricecards {
	margin-bottom: 1rem;
	display: grid;
	grid-template-columns: 1fr 1fr;
	align-items: flex-end;
	grid-gap: .5rem;
}

ul.pricecards li img {
	max-width: 100%;
}

@media screen and (max-width: 600px) {
	ul.pricecards {
		display: block;
	}

	ul.pricecards li {
		text-align: center;
		margin: 0 1rem;
	}

	ul.pricecards li:first-child {
		margin-bottom: 1rem;
	}
}
</style>
